@if (currentUser$ | async; as currentUser){
    <h1 class="text-center">Your Account</h1>
    <div class="flex gap-4 align-middle items-center">
        <img [src]="currentUser?.gravatar" alt="" class="rounded">
        <div>
            <h2>{{ currentUser?.firstname }} {{ currentUser?.surname}}</h2>
            <p class="text-sm italic -mt-4">{{ currentUser?.email }}</p>
        </div>
    </div>
    <h1 class="text-center mt-3">Your Bookings</h1>
    <div class="overflow-hidden">
        @if (upcomingBookings$ | async; as upcomingBookings){
            @for (booking of upcomingBookings; track booking.bookingID){
                <app-event-booking-tile [booking]="booking" />
            } 
        } 
    </div>
}